import { Component } from 'react'
import { Dispatch } from 'react-redux'
import { API_SUCCESS } from '../../../helper/constant/api_status'
import { getDashboard } from '../../../services/api/accounting/dashboard'
import { getAdminDashboardFilter } from '../../../services/api/admin/dasbboard'
import moment from 'moment'

type Props = {
    school: Object,
    dispatch: Dispatch<any>,
}

type State = {}

export class AbstractAdminDashboardComponent extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            loading: false,
            userCount:{},
            book:{},
            employeeAttendance:{},
            studentAttendance:{},
            holidays:[],
            events:[],
            exams:[],
            packageData: null,
            storage: 0,
            employee: 0,
            student: 0,
            progressStatus: [
                { label: 'Student', translate: 'todo:student', bgcolor: '#656294', completed: 0, max: '100', isStorage: false },
                { label: 'Employee', translate: 'user_filter:employee', bgcolor: '#fd6569', completed: 0, max: '100', isStorage: false },
                { label: 'Storage', translate: 'common:storage', bgcolor: '#53b88e', completed: 0, max: '100', isStorage: true },
            ],

        }
        this._handleChange = this._handleChange.bind(this)
    }

    componentDidMount() {
        this.loadDashboard()
    }

    _handleChange(key, data) {
        this.setState({ [key]: data })
    }

    loadDashboard() {
        this._handleChange('loading', true)
        const from = moment().startOf('month').format('YYYY-MM-DD');
        const to = moment().format('YYYY-MM-DD');
        const time = moment().format('HH:mm'); 
        getAdminDashboardFilter(this.props.token, from, to, time).then((response) => {
            this._handleChange('loading', false)
            console.log(this.props.token, "test")
            if (response.code == API_SUCCESS) {
                console.log(response.data)
                const data = response.data

                const packageData = data?.Subscription?.package[0]
                console.log("packageabstract", packageData)
                const progressStatus = [
                    { label: 'Student', translate: 'todo:student', bgcolor: '#656294', completed: data?.Subscription?.studentCount, max: packageData.student, isStorage: false },
                    { label: 'Employee', translate: 'user_filter:employee', bgcolor: '#fd6569', completed: data?.Subscription?.employeeCount, max: packageData.teacher, isStorage: false },
                    { label: 'Storage', translate: 'common:storage', bgcolor: '#53b88e', completed: data?.Subscription?.storage, max: packageData.storage, isStorage: true },
                ]
                this.setState({
                    userCount: data.userCount,
                    employeeAttendance: data.attendanceCount.employeeAttendance,
                    studentAttendance: data.attendanceCount.studentAttendance,
                    book: data.book,
                    events: data.calendar?.events,
                    holidays: data.calendar?.holidays,
                    exams: data.exam,
                    packageData,
                    storage: data.storage,
                    employee: data.employee,
                    student: data.student,
                    progressStatus,

                })
            }
        })
    }
}

export function mapStateToProps(state: Object) {
    return {
        token: state.token,
        school: state.school.school,
    }
}
